<script setup lang="ts">
    import { RefreshCw } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import { ref, watch } from 'vue';

    const props = defineProps<{
        isFetching: boolean;
    }>();

    const isLoading = ref(false);

    watch(
        () => props.isFetching,
        (newVal, oldVal) => {
            if (oldVal === true && newVal === false) {
                isLoading.value = false;
            }
        },
    );

    const emit = defineEmits<{
        (e: 'refetch'): void;
    }>();

    const handleRefetch = () => {
        isLoading.value = true;
        emit('refetch');
    };
</script>

<template>
    <Button
        @click.stop="handleRefetch"
        variant="ghost_primary"
        width="narrow"
        class="self-start"
        size="xs"
        :disabled="isFetching"
    >
        {{ $t('datatables.reload_table') }}
        <RefreshCw
            class="text-primary"
            :class="{ 'animate-spin': isLoading }"
        />
    </Button>
</template>
